// extracted by mini-css-extract-plugin
export default {"formGroup":"styles_formGroup__QCfj0","label":"styles_label__jWAdN"};